<resource-attributes [resource]="collection$ | async" [attributesResourceType]="collectionType"></resource-attributes>
